<ion-datetime presentation="date"
              color="success"
              [min]="from"
              [max]="to"
              [(ngModel)]="selectedDate"></ion-datetime>
<ion-buttons slot="buttons">
    <ion-button color="gray" style="margin-left: auto" (click)="onCancel()">Cancel</ion-button>
    <ion-button color="success" (click)="onSelect()">Done</ion-button>
</ion-buttons>
